import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

const NavItem = ({ id, label, icon, current, hideOnLarge, onClick }) => {
    const handleClick = () => onClick(id);

    return (
        <div className={'horizontal-nav-item' + (current === id ? ' active' : '') + (hideOnLarge ? ' hide-on-large' : '')} data-text={label} onClick={handleClick}>
            { label }
        </div>
    )
}

const MilestoneTasksNav = ({ openTasksCount, completedTasksCount, current, onClick, t }) => {
    return (
        <div className="horizontal-nav content-panel-nav content-panel-nav-centered">
            <NavItem
                id="open"
                current={current}
                onClick={onClick}
                label={
                    <React.Fragment>
                        { t('Open Tasks') }

                        <span className="label-bubble">{openTasksCount}</span>
                    </React.Fragment>
                }
            />

            <NavItem
                id="completed"
                current={current}
                onClick={onClick}
                label={
                    <React.Fragment>
                        { t('Completed Tasks') }

                        <span className="label-bubble">{completedTasksCount}</span>
                    </React.Fragment>
                }
            />
        </div>
    );
};

export default withTranslation('task')(MilestoneTasksNav);
